const moc = { t: 'Moc', name: 'moc', type: 'number', unit: 'KM' }
export default moc